'use strict';

// Keep synced with stampsy.models.User#EmailFlags on server
var EmailFlags = {
  // Your stamp is published
  STAMP_PUBLISHED: 0x00001,
  // Your stamp becomes trending on Stampsy
  TRENDING_STAMP: 0x00002,
  // Somebody follows me or my collections
  NEW_SUBSCRIBER: 0x00004,
  // Your submission to another collection gets approved or declined
  SUBMISSION_APPROVED_OR_DECLINED: 0x00008,
  // Weekly reminder about submissions to your collections
  WEEKLY_PENDING_REMINDER: 0x00010,
  // Your collection gets a new submission
  STAMP_SUBMITTED_TO_COLLECTION: 0x00020,
  // Somebody adds your stamp to their collection
  YOUR_STAMP_ADDED_TO_COLLECTION: 0x00040,
  // Somebody used your image in their stamp
  COLLECTED_IMAGE_PUBLISHED: 0x00080,
  // Weekly digest with best stamps and Stampsy updates
  WEEKLY_DIGEST_AND_MISC: 0x00100,
  // Somebody left feedback to your draft
  DRAFT_FEEDBACK: 0x00200,
};

module.exports = EmailFlags;


/** WEBPACK FOOTER **
 ** ./constants/EmailFlags.js
 **/